export const round = (value: number, dec: number): number =>
  value % 1 ? parseFloat(value.toFixed(dec)) : value
